import { jsx } from "react/jsx-runtime";
import { Divider, Link, Box, Typography } from "@tino-frontend/coreui";
import { formatProps } from "./format-props.js";
function MarkdownLink({
  children,
  allLinkAsTargetBlank,
  node,
  // eslint-disable-line
  ...isProps
}) {
  return /* @__PURE__ */ jsx(
    Link,
    {
      variant: "body1",
      target: allLinkAsTargetBlank ? "_blank" : void 0,
      ...isProps,
      children
    }
  );
}
function MarkdownParagraph(props) {
  const { children = [""], marginSpacing = 0, node, ...isProps } = props;
  const [first = ""] = children;
  const parsedProps = formatProps(isProps);
  return first === " " ? /* @__PURE__ */ jsx(Box, { pb: marginSpacing }) : /* @__PURE__ */ jsx(Typography, { mb: marginSpacing, ...parsedProps, children });
}
function MarkdownList({ children, ...isProps }) {
  return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Typography, { variant: "body1", color: "text.medium", ...isProps, children }) });
}
const MarkdownHR = Divider;
function MarkdownHeading(props) {
  const {
    level,
    limitHeading,
    reduceHeading,
    children,
    marginSpacing = 2,
    node,
    // eslint-disable-line
    ...isProps
  } = props;
  const headingSize = resizeHeading(level, limitHeading);
  const defaultProps = transformHeading(headingSize, reduceHeading);
  return /* @__PURE__ */ jsx(Typography, { mb: marginSpacing, ...defaultProps, ...isProps, children });
}
function resizeHeading(number, limitHeading) {
  return limitHeading && number <= limitHeading ? `h${limitHeading}` : `h${number}`;
}
function transformHeading(variant, reduceHeading) {
  const variantMap = {
    h1: { variant: "h2" },
    h2: { variant: "h3" },
    h3: { variant: "h4" },
    h4: { variant: "h5" },
    h5: { variant: "h6" },
    h6: { variant: "body1", fontWeight: "bold" }
  };
  if (reduceHeading) {
    return variantMap[variant] || { variant };
  } else {
    return { variant };
  }
}
export {
  MarkdownHR,
  MarkdownHeading,
  MarkdownLink,
  MarkdownList,
  MarkdownParagraph
};
//# sourceMappingURL=elements.component.js.map
